import { render } from "./BenefitGameTopup.vue?vue&type=template&id=7c73599b"
import script from "./BenefitGameTopup.vue?vue&type=script&lang=js"
export * from "./BenefitGameTopup.vue?vue&type=script&lang=js"
script.render = render

export default script